import { observer } from 'mobx-react';
import React from 'react';

import { DbKey, makeWithDbId, WithDbId } from '../../../../adl-gen/common/db';
import { Question, Skill } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { RepositoryEntrySet } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { QuestionCompetencySkillsMap, QuestionStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { QuestionAnswerForm } from '../../components/forms/question-answer-form/question-answer-form';
import { QuestionAnswerDetailsView } from '../../components/detail-views/question-answer-details-view';

interface QuestionAnswerDetailScreenProps {
  pageLayout: AdminPageLayoutFn;

  mode?: FormMode;

  repository: MaybeLoading<RepositoryEntrySet>;
  competencySkillsMap: MaybeLoading<QuestionCompetencySkillsMap>;
  skillId?: DbKey<Skill>;
  store: QuestionStore;

  onCancel?(): Promise<void>;
  onUpdate?(id: DbKey<Question>): Promise<void>;
}

@observer
export class QuestionAnswerDetailScreen extends React.Component<QuestionAnswerDetailScreenProps> {
  renderQuestionDetails = observer((competencySkillsMap: QuestionCompetencySkillsMap) => {
    const { onUpdate, store } = this.props;

    if (store.selectedEntry && onUpdate) {
      const skill =
        store.selectedEntry.skillId !== null ? competencySkillsMap.skills.get(store.selectedEntry.skillId) : undefined;
      return (
        <QuestionAnswerDetailsView
          question={store.selectedEntry}
          skill={skill}
          onUpdate={onUpdate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    }
    return null;
  });

  renderCreateQuestionAnswerForm = observer((competencySkillsMap: QuestionCompetencySkillsMap) => {
    const {
      // mode,
      onCancel,
      skillId,
      store
    } = this.props;

    const skill = skillId ? competencySkillsMap.skills.get(skillId) : undefined;
    const skillWithId = skillId && skill ? makeWithDbId({ id: skillId, value: skill }) : undefined;

    console.debug(
      'render create onCancel = undefined, loadingrepos kind',
      onCancel === undefined,
      store.loadingRepository.kind
    );
    if (onCancel && store.loadingRepository.kind === 'value') {
      return (
        <QuestionAnswerForm
          skill={skillWithId}
          competencySkillsMap={competencySkillsMap}
          repository={store.loadingRepository.value}
          store={store}
          onCancel={onCancel}
        />
      );
    } else {
      return null;
    }
  });

  renderUpdateQuestionAnswerForm = observer((item: WithDbId<Question>) => {
    const { competencySkillsMap, onCancel, repository, store } = this.props;

    const map = competencySkillsMap.kind === 'value' ? competencySkillsMap.value : undefined;
    const repos = repository.kind === 'value' ? repository.value : undefined;
    if (onCancel && map && repos) {
      return (
        <QuestionAnswerForm
          question={item}
          competencySkillsMap={map}
          repository={repos}
          store={store}
          onCancel={onCancel}
        />
      );
    } else {
      return null;
    }
  });

  QuestionAnswerDetailsLoader = () => {
    const { competencySkillsMap, store, mode } = this.props;
    const question = store.selected;
    if (question) {
      if (mode === 'update' || mode === 'delete') {
        return <Loader state={question} LoadedComponent={this.renderUpdateQuestionAnswerForm} />;
      } else {
        /// View
        return <Loader state={competencySkillsMap} LoadedComponent={this.renderQuestionDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <Loader state={competencySkillsMap} LoadedComponent={this.renderCreateQuestionAnswerForm} />;
    }
  };

  render() {
    return (
      <this.props.pageLayout title={'Administration - Questions and Answers'}>
        <this.QuestionAnswerDetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/question-answer-detail-screen/question-answer-detail-screen.tsx